// extracted by mini-css-extract-plugin
module.exports = {"container":"whoops_container__3D87h","heading":"whoops_heading__1NACg","icon":"whoops_icon__2Wnjg"};